var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderBookBidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.0007 9C18.0007 13.9706 13.9713 18 9.00074 18C9.00034 12.375 9.00049 13.9706 9.00049 9C9.00049 4.02944 9.00049 6.1875 9.00074 0C13.9713 0 18.0007 4.02944 18.0007 9Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000240326 9C0.000240326 13.9706 4.02968 18 9.00024 18C9.00064 12.375 9.00049 13.9706 9.00049 9C9.00049 4.02944 9.00049 6.1875 9.00024 0C4.02968 0 0.000240326 4.02944 0.000240326 9Z",
    fill: "#F35B37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderBookBidIcon);
export default __webpack_public_path__ + "static/media/order-book-bid-icon.e20976a7981a8a4f5cab4d6f186debcf.svg";
export { ForwardRef as ReactComponent };